exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".auth-text[data-v-11f8cec9] {\n  margin-bottom: 20px;\n}", ""]);

// exports
